import { Component, inject, signal, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'lbt-mobile-header',
  standalone: false,
  templateUrl: './mobile-header.component.html',
  styleUrl: './mobile-header.component.scss',
})
export class MobileHeaderComponent {
  private readonly matDialog = inject(MatDialog);
  private readonly router = inject(Router);

  private mainMenu: MatDialogRef<any> | null = null;

  protected readonly isMenuOpened = signal<boolean>(false);

  @ViewChild('mainMenuTmpl') mainMenuTmpl!: TemplateRef<any>;

  toggleMenu ()  {
    if(this.mainMenu){
      this.mainMenu.close();
    } else {
      this.mainMenu = this.matDialog.open(this.mainMenuTmpl,{
        panelClass: 'mobile-right-dialog',
        minWidth: '300px',
        exitAnimationDuration: 500,
        height: 'calc(100dvh - 70px)',
        position: { top: '70px', right: '0' }
      });
      this.isMenuOpened.set(true);
      this.mainMenu.afterClosed().subscribe(() => {
        this.mainMenu = null;
        this.isMenuOpened.set(false);
      });

    }
  }

  navigateToMainPage() {
    // Go straight to the mobile root. Navigating to '' resolves to the desktop
    // /shipments path, which RedirectToMobilePageGuard then cancels and
    // re-navigates to the mobile path — re-running the leaving page's
    // canDeactivate and showing the "Unsaved changes" dialog twice.
    this.router.navigate(['/mobile']);
  }

}
